import { render, staticRenderFns } from "./CommissionRecipientOverrideForm.vue?vue&type=template&id=3fa11476"
import script from "./CommissionRecipientOverrideForm.vue?vue&type=script&lang=js"
export * from "./CommissionRecipientOverrideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports